module.exports = __webpack_public_path__ + "h5/img/i_nav3.7e83499d.png";